<template lang="pug">
k-page.release( :class="postData.release_type" :key='postData.id' ref='page' )
  template( v-if=`layout === 'suave'` )
    k-browser-content
  template( v-else )
    d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
    k-hero
    k-main( :title='title' )
      media-info-icons( :post='post || storedPost' v-bind='{ postData }' )

      //- TODO: strips for related, series
      section.description( v-if='wideMode' v-html='content' )
      filmstrip(
        v-if='series'
        title='in this series'
        :contents='series'
        :current='postData.id'
      )
      comments
  .bottom-spacer
</template>

<script lang="js">
import { mapActions, mapGetters } from 'vuex'
import he from 'he'
import orderBy from 'lodash-es/orderBy'
import routeEvents from '@/lib/route-events'
import Filmstrip from '@/components/filmstrip'
import DMainImage from '@/displays/d-main-image'
import KBrowserContent from '@/blocks/k-browser-content'
import KPage from '@/blocks/k-page'
import KHero from '@/blocks/k-hero'
import KMain from '@/blocks/k-main'
import Comments from '@/components/comments'
import MediaInfoIcons from '@/components/media-info-icons'
import mediaActions from '@/mixins/media-actions'
import { Page } from '@/mixins'

export default {
  name: 'ReleasePage',
  mixins: [ mediaActions, Page ],
  components: {
    DMainImage,
    KBrowserContent,
    KPage,
    KHero,
    KMain,
    Filmstrip,
    Comments,
    MediaInfoIcons
  },
  props: [],
  data() {
    return {
      storedPost: {
        stats: {},
        my_xp: {}
      },
      prev: 0,
      next: 0,
      wideMode: true
    }
  },
  beforeRouteUpdate: routeEvents.toRelease,
  created() {},
  mounted() {
    this.loading = false
    this.setHero({
      name: 'video-full',
      data: {
        content: this.postData,
        series: this.series || [ this.postData ]
      }
    })
  },
  methods: {
    ...mapActions([ 'setHero', 'updateHeroData' ]),
  },
  computed: {
    ...mapGetters([ 'layout' ]),
    promos() {
      return [{
        id: this.postData.id,
        excerpt: { rendered: this.content }
      }].concat( this.postData.promo_reel || [])
    },
    episodes() {
      return this.postData.releases || []
    },
    content() {
      return this.postData.content ? this.postData.content.rendered
         : this.postData.caption ? this.postData.caption.rendered : ''
    },
    classes() {
      return { small: !!this.promos.length }
    },
    series() {
      if ( !this.postData.series || this.postData.series.length < 2 ) {
        return false
      }
      var episodes = orderBy(
        this.postData.series,
        [ 'release_number' ],
        [ 'asc' ]
      )
      var series = episodes.filter(
        x => this.canWatchNow(x) || x.restrictions.show
      )
      return series.length && series
    }
  },
  watch: {
    $route( to, from ) {
      this.storedPost = Object.assign( {}, this.$store.state.post )
      document.title = he.decode( this.title + ' | ' + this.siteTitle )
      this.$nextTick(() => {
        this.setHero({
          name: 'video-full',
          data: {
            content: this.storedPost,
            series: this.series || [ this.storedPost ]
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.release {
  h1.title {
    margin-top: 0;
    font-size: var(--s-xl);
  }
}
</style>
